
import {
  REQUEST_LINKEDIN_PAGES,
  CLEAR_LINKED_PAGE_LIST
} from '../constants/actionTypes';

const INITIAL_STATE = { pages: [], error: null };

export default function linkedinPages(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_LINKEDIN_PAGES:
      return {
        pages: action.payload,
        error: null
      };
    case CLEAR_LINKED_PAGE_LIST:
      return {
          pages: [],
          error: null
      };
    default:
      return state;
  }
}
